/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { createSelector, createSlice } from '@reduxjs/toolkit';
import { ThunkStatus } from '../../../enums/ThunkStatus';
import { removeUsersFromOrg } from './users.remove.thunk';

/* Initial State */
const initialState = {
  status: ThunkStatus.IDLE,
  userIds: undefined,
  dialog: { open: false },
  deleteButton: { visible: false },
  error: undefined,
};

/* Slice */
export const removeUsersFromOrgSlice = createSlice({
  name: 'removeUsers',
  initialState,
  reducers: {
    toggleDialog(state, action) {
      state.dialog.open = action.payload;
    },
    toggleDeleteButton(state, action) {
      state.deleteButton.visible = action.payload;
    },
    updateUserIds(state, action) {
      state.userIds = action.payload;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(removeUsersFromOrg.pending, (state) => {
        state.status = ThunkStatus.LOADING;
      })
      .addCase(removeUsersFromOrg.fulfilled, (state, action) => {
        state.status = ThunkStatus.SUCCEEDED;
        state.users = action.payload;
        state.dialog.open = false;
        state.deleteButton.visible = false;
        state.error = undefined;
      })
      .addCase(removeUsersFromOrg.rejected, (state, action) => {
        state.status = ThunkStatus.FAILED;
        state.error = action?.error?.message;
      });
  },
});

/* Selectors */
const selectRemoveUserSlice = state => state[removeUsersFromOrgSlice.name];

export const selectDialog = createSelector(selectRemoveUserSlice, s => s.dialog);
export const selectStatus = createSelector(selectRemoveUserSlice, s => s.status);
export const selectDeleteButton = createSelector(selectRemoveUserSlice, s => s.deleteButton);
export const selectUserIds = createSelector(selectRemoveUserSlice, s => s.userIds);

/* Actions */
export const { toggleDialog, updateUserIds, toggleDeleteButton } = removeUsersFromOrgSlice.actions;
